import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function LogIn({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
    >
      <Path
        d="M6.66671 2.66669C6.29852 2.66669 6.00004 2.96516 6.00004 3.33335V9.33335H7.33337V4.00002H18.6667V20H7.33337V14.6667H6.00004V20.6667C6.00004 21.0349 6.29852 21.3334 6.66671 21.3334H19.3334C19.7016 21.3334 20 21.0349 20 20.6667V3.33335C20 2.96516 19.7016 2.66669 19.3334 2.66669H6.66671ZM16.4714 11.5286L11.8048 6.86195L10.862 7.80476L14.3906 11.3334H1.33337V12.6667H14.3906L10.862 16.1953L11.8048 17.1381L16.4714 12.4714C16.7318 12.2111 16.7318 11.789 16.4714 11.5286Z"
        fill={iconColor}
      />
    </Svg>
  );
}
